<template>
  <b-modal no-fade v-model="dialog.show" size="lg"  :id="`modal-titan-${uniqueId}`"
           :hide-footer="true" centered @close="onDialogClose"
           no-close-on-backdrop
  >
    <template #modal-title>
     <span v-if="loading !== true && error == null && titan != null && titan.id != null">
       {{ titan.email }}
     </span>
    </template>
    <div style="min-height: 600px">
      <div v-if="loading !== true && error == null">
        <titan-edit-details v-bind:new-titan="isNewTitan" v-model="titan" @close="closeModal" />
      </div>
      <div class="text-center position-absolute d-block w-100" style="top:50%" v-else-if="loading !== true && error != null">
        <b-alert show variant="danger" >
          <i class="fa-sharp fa-solid fa-triangle-exclamation"></i>
          {{ error }}
        </b-alert>
      </div>
      <div class="text-center position-absolute d-block w-100" style="top:50%" v-else>
        <b-spinner>{{$t('operations.loading')}}</b-spinner>
      </div>
    </div>
  </b-modal>
</template>

<script>
import mixinBase from '@/components/mixin/mixinBase'
import mixinNotifications from '@/components/mixin/mixinNotifications'
import { mapActions } from 'vuex'
import TitanEditDetails from '@/components/partial/campaigns/TitanEditDetails'
import Titan from '@/model/campaign/Titan'

export default {
  name: 'titanModal',
  components: { TitanEditDetails },
  mixins: [mixinBase, mixinNotifications],
  data: () => ({
    dialog: {
      show: false,
    },
    uniqueId: 0,
    loading: true,
    error: null,
    id: null,
    isNewTitan: false,
    titan: {}
  }),
  watch: {
    queryParams:{
      handler(){
        if(this.queryParams().titanId == null) {
          this.closeModal()
          return
        }
        if (this.queryParams().titanId !== this.id) {
          this.showModal(this.queryParams().titanId)
        }
      },
      deep: true
    }
  },
  created() {
    this.uniqueId = this._uid
    if(this.queryParams().titanId != null) {
      this.showModal(this.queryParams().titanId)
    }
  },
  methods: {
    ...mapActions('titan', ['getTitanById']),
    showModal(id) {
      this.id = id
      this.loading = true
      this.dialog.show = true
      this.dialog.tab = 0
      this.isNewTitan = this.id == null || this.id === 0;
      if(!this.isNewTitan) {
        this.refreshData()
      }else {
        this.titan = Titan()
        this.error = null
        this.loading = false
      }
      this.pushState({titanId: id, tab: 0, })
    },
    closeModal(){
      this.dialog.show = false;
      this.titan = {}
      this.onDialogClose()
    },
    onDialogClose(){
      this.id = null;
      this.pushState({titanId: null, tab: null, })
    },
    refreshData() {
      let $this = this;
      this.getTitanById(this.id)
          .then(titan => {
            $this.titan = titan;
            $this.error = null
            $this.loading = false
          }, err => {
            $this.error = $this.getErrorDescription(err)
            $this.loading = false
          })
    },
  }
}
</script>

<style scoped>

</style>
